// extracted by mini-css-extract-plugin
module.exports = {"Label":"nft-marketplace-listing_Label__Z_zeP"};